/** Vuex store */
import Vue from 'vue'
import Vuex from 'vuex'
import DataProcessor from './dataProcessor'
import actions from './actions'
import scopeActions from '../templates/scopeActions'

import watcherSocketPlugin from './plugins/watcherSocketPlugin'
import loginActions from '../templates/loginActions'
import ssoActions from "../templates/sso-redirecting/ssoActions";

Vue.use(Vuex)

let dataProcessor = null
export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [watcherSocketPlugin],
  state: {
    access_token: null,
    timezone_type: 'user', // user, local
    loading: [],
    users: [],
    scope: {
      filters: {
        atmStatuses: ['PASS', 'FAIL'],
        atmTypes: ['balance', 'non_cash_withdraw', 'transfer', 'withdraw'],
        paymentStatuses: ['paid', 'deposited', 'failed', 'pending', 'declined', 'reversed', 'overpaid', 'cancelled', 'dispensed', 'approved', 'refund',
        'reviewing', 'collected', 'transferred', 'received', 'partial', 'pass', 'canceled',
        'checked', 'paying', 'rewarded', 'opened', 'review'],
        alertDeviceTypes: ['scanner', 'check_reader', 'voice', 'pin_pad', 'printer', 'system',
        'cash_dispenser', 'bill_recycler', 'clamshell', 'bill_acceptor', 'fingerprint', 'card_reader'],
        alertTypes: [ 'offline', 'disconnected', 'connected', 'jam', 'empty', 'low', 'full',
          'opened', 'exception', 'general', 'fail', 'version', 'support', 'support_check', 'check_review',
          'notFound', 'outOfRange', 'error', 'warning', 'fatal', 'customer_report'],
      },
      timezone_list: [
        { name: 'US/Eastern', label: 'Eastern Time' },
        { name: 'US/Central', label: 'Central Time' },
        { name: 'US/Mountain', label: 'Mountain Time'},
        { name: 'US/Pacific', label: 'Pacific Time' },
        { name: 'US/Alaska', label: 'Alaska Time' },
        { name: 'US/Hawaii', label: 'Hawaii Time' }
      ],
      modalsPayload: {}
    }
  },

  mutations: {
    setUser (state, val) {
      state.users = [val]
      const usertimezone = val.time_zone
      const time_zone_list = state.scope.timezone_list
      if (usertimezone) {
        const index = _.findIndex(time_zone_list, { 'name': usertimezone })
        if (index === -1) {
          time_zone_list.push({name: usertimezone, label: usertimezone, isUser: true })
        } else {
          time_zone_list[index].isUser = true
        }
      }
    },

    setToken (state, token) {
      state.access_token = token
    },

    setCommunication(state, val) {
      Vue.set(state, 'communication', val);
    },

    subStart (state, val) {
      state.loading.push(val)
    },

    subEnd (state, val) {
      // Vue.set(state, 'loading', state.loading.filter(item => item !== val))
      state.loading = state.loading.filter(item => item !== val)
    },

    setModalPayload(state, payload) {
      state.scope.modalsPayload = {...state.scope.modalsPayload, ...payload}
    },

    createCollection (state, {collection}) {
      Vue.set(state, collection,  [])
    },

    pushCollection (state, {collection, object}) {
      state[collection].push(object)
    },

    removeItem (state, {collection, index}) {
      Vue.delete(state[collection], index)
    },

    updateCollection (state, {collection, index, object}) {
      Vue.set(state[collection], index, object)
    },

    updateRecordInCollection (state, {collection, index, object}) {
      Vue.set(state[collection], index, {...state[collection][index], ...object})
    },

    setCollectionData(state, {collection, data = []}) {
      Vue.set(state, collection,  data)
    }
  },

  actions: {
    createDataProcessor(store) {
      dataProcessor = new DataProcessor(store)
    },

    [actions.STORE_ITEM_CREATE] (context, payload) {
      const { collection, id, object } = payload

      if (context.state[collection]) {
        const itemIndex = _.findIndex(context.state[collection], {id})
        if (itemIndex !== -1) return console.log('Ignore item because exists', payload)
      } else {
        context.commit('createCollection', {collection})
      }

      object.id = id

      dataProcessor.process(collection, object)
      context.commit('pushCollection', {collection, object})
    },

    [actions.STORE_ITEM_UPDATE] (context, payload) {
      const { collection, id, object } = payload

      object.id = id

      const target = context.state[collection]
      const index = _.findIndex(target, { id })

      if (index !== -1) {
        dataProcessor.process(collection, new Proxy(object, {
          get(t, p) {
            if (_.has(t, p)) return t[p];
            const json = JSON.stringify(target[index][p])
            if (!json) return target[index][p];
            return JSON.parse(json);
          },
        }));
        context.commit('updateRecordInCollection', {collection, index, object})
      } else {
        console.error('Index to replace is not found', index, payload)
      }
    },

    [actions.STORE_ITEM_REPLACE] (context, payload) {
      const { collection, id, object } = payload

      object.id = id

      const target = context.state[collection]
      const index = _.findIndex(target, { id })

      if (index !== -1) {
        dataProcessor.process(collection, object)
        context.commit('updateCollection', {collection, index, object})
      } else {
        console.error('Index to replace is not found', index, payload)
      }
    },

    [actions.STORE_RESET_COLLECTION] (context, payload) {
      const { collection } = payload

      context.commit('createCollection', {collection})
    },

    [actions.STORE_ITEM_REMOVE] (context, payload) {
      const { collection, id } = payload
      const index = _.findIndex(context.state[collection], { id })

      if (index === -1) {
        return console.error('Item to delete is not found', payload)
      }

      context.commit('removeItem', {collection, index})
    },

    [actions.STORE_BULK_INSERT_DATA] (context, payload) {
      const {collection, data} = payload

      if (!collection) {
        return console.error('Collection name is not provided')
      }

      context.commit('setCollectionData', {collection, data})
    },

    async [actions.LOG_IN_USER] (context, payload) {
      const {access_token} = payload

      const userData = await loginActions.loginMe({access_token})

      if (userData.error) {
        throw new Error(userData.error)
      }

      Vue.prototype.$user = userData.user
      Vue.prototype['_isAdmin'] = userData.user.partner_id === 0 //todo need reworked to permissions

      localStorage.setItem('token', userData.token)
      context.commit('setToken', userData.token)
      context.commit('setUser', userData.user)

      Vue.prototype.$user_sso_permissions = await ssoActions.getUserPermissions();
    },

    //todo removed later already modal reworked to new way communicate among ourselves  ...
    [actions.MODAL_PAYLOAD_SET_COMMIT] (context, payload) {
      if (!_.isObjectLike(payload)) {
        return console.error('modal payload should be an object')
      }

      if (Object.keys(payload).length) {
        context.commit('setModalPayload', payload)
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js